// extracted by mini-css-extract-plugin
export default {"text":"Events_text__VtWFt","inner":"Events_inner__vHJwT","part":"Events_part__SJL0n","heading":"Events_heading__OWCDy","linkEvent":"Events_linkEvent__+b6Gw"};